import { NgModule } from '@angular/core';
import { GenericDetailsComponent } from './generic-details.component';
import { GenericDetailsRoutingModule } from './generic-details-routing.module';
import { GenericService } from './generic.service';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [GenericDetailsRoutingModule, SharedModule],
  declarations: [GenericDetailsComponent],
  exports: [GenericDetailsComponent],
  providers: [GenericService]
})
export class GenericDetailsModule { }
